import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NzMessageService } from 'ng-zorro-antd/message';
import {
  RobiServiceProvider,
  ServiceProvider,
} from 'src/app/models/enums/service-provider.enum';
import { AuthService } from 'src/app/services/auth-service';
import { ConfigService } from 'src/app/services/config-service.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-robi-documentation',
  templateUrl: './robi-documentation.component.html',
  styleUrls: ['./robi-documentation.component.scss'],
})
export class RobiDocumentationComponent {
  successRes = `
  { 
    "statusCode": 200, 
    "message": "Successful", 
    "data": [ 
        { 
            "serviceId": "0000000000", 
            "title": "Title 01", 
            "validity": "Monthly", 
            "price": 0.0,
            "isRenewal" : true
        }, 
        { 
            "serviceId": "0000000000", 
            "title": "Title 02", 
            "validity": "Daily", 
            "price": 0.0 ,
            "isRenewal" : true
        }, 
        { 
            "serviceId": "0000000000", 
            "title": "Title 03", 
            "validity": "Weekly", 
            "price": 0.0 ,
            "isRenewal" : true
        } 
    ] 
} `;
  wrongServiceRes = `
    { 
        "statusCode": 500, 
        "message": "Something went wrong! Please try again.", 
        "data": null 
    }`;

  reqBody = `
    { 
        "MSISDN": "880100000000", 
        "ServiceId": "2251" ,
        "PaymentSuccessRedirectUrl" : "https://www.example.com/success",
        "PaymentFailedRedirectUrl" : "https://www.example.com/failed"
    } 
 `;
//   reqSucRes = `
//     { 
//         "statusCode": 200, 
//         "message": "Successfull" 
//     }
//  `;
  reqSucRes = `
{
    "statusCode": 200,
    "message": "",
    "data": {
        "paymentUrl": "http://robi.mife-aoc.com/api/aoc?aocToken=charging_initiate_token"
    }
}`;

  otpVerifyReqBody = `
 { 
    "MSISDN": "880100000000", 
    "ServiceId": "000000000", 
    "ConsentNo": "00000" 
} `;

  optVerifySucRes = `
{ 
    "statusCode": 200, 
    "message": "Successfull" 
} `;

  optVerifyServerError = `
{ 
    "statusCode": 500, 
    "message": "Something went wrong! Please try again.", 
    "data": null 
}  `;

  reqServerErrorRes = `
    { 
        "statusCode": 500, 
        "message": "Something went wrong! Please try again.", 
        "data": null 
    }  
 `;
  checkReqRes = `
  Response when "isShowAll" is false:

 {
     "statusCode": 200,
     "message": "Successful",
     "data": {
         "msisdn": "880100000000",
         "serviceId": "00000000",
         "nextRenewalDate": 0
     }
 }
 

 Response when "isShowAll" is true:
 
{
    "statusCode": 200,
    "message": "Successful",
    "data": [
        {
            "msisdn": "88018XXXXXXXX",
            "serviceId": "00000000",
            "nextRenewalDate": 0
        }
    ]
}
 `;
  checkNotFoundRes = `
    {
        "statusCode": 200,
        "message": "Not found any subscription",
        "data": null
    }
 `;
  subscriptionCheckApiNotFoundRes = `
 {
     "statusCode": 200,
     "message": "Not found any subscription",
     "data": null
 }
`;
  cancelReq = `
  "message": "successful"
 `;
  cancelRes = `
  "message": "{message}"`;
  vendor: string | null = null;
  apiRouteSegment: string = '';
  domain = environment.apiUrl;
  checkSubscriptionApi: string = '';
  checkSubscriptionApiWithTrue: string = '';
  cancelSubscriptionApi: string = '';
  productsApi: string = '';
  createCheckoutSessionApi: string = '';
  verifyCheckoutSessionApi: string = '';
  isValidProvider: boolean = false;

  constructor(
    private config: ConfigService,
    private route: ActivatedRoute,
    public authService: AuthService,

    private message: NzMessageService
  ) {
    this.route.params.subscribe((params) => {
      if (params['id']) {
        this.config.getRobiDetailsByMarchent(params['id']).subscribe((e) => {
          console.log(e);
          if (e && e.length > 0) {
            this.vendor = e[0].merchant;

            this.initializeApiRoutes();
          }
        });
      }
    });

    this.route.queryParams.subscribe((params) => {
      const serviceProvider: string = params['serviceProvider'];
      if (
        serviceProvider &&
        serviceProvider == RobiServiceProvider.Cloud7Ltd.toString()
      ) {
        this.apiRouteSegment = 'robicloud7';
        this.isValidProvider = true;
      } else if (
        serviceProvider == RobiServiceProvider.ShadhinMusicLtd.toString()
      ) {
        this.apiRouteSegment = 'robi';
        this.isValidProvider = true;
      } else if (
        serviceProvider == RobiServiceProvider.Robi_Maverick.toString()
      ) {
        this.apiRouteSegment = 'robi_maverick';
        this.domain = 'https://payment.immaverick.com';
        this.isValidProvider = true;
      } else {
        this.isValidProvider = false;
      }
    });
  }

  getMessage() {
    if (this.isValidProvider) {
      return 'Not found any docs for you please contact with administrator.';
    } else {
      return `No service provider found please contact with administrator.`;
    }
  }

  initializeApiRoutes() {
    this.checkSubscriptionApi = `${this.domain}/${this.apiRouteSegment}/billing/check-subscription/${this.vendor}/8800000000000?isShowAll=false`;
    this.checkSubscriptionApiWithTrue = `${this.domain}/${this.apiRouteSegment}/billing/check-subscription/${this.vendor}/8800000000000?isShowAll=true`;
    this.cancelSubscriptionApi = `${this.domain}/${this.apiRouteSegment}/billing/cancel-subscription`;
    this.productsApi = `${this.domain}/${this.apiRouteSegment}/billing/products/${this.vendor}`;
    this.createCheckoutSessionApi = `${this.domain}/${this.apiRouteSegment}/checkout/create-checkout-session`;
    this.verifyCheckoutSessionApi = `${this.domain}/${this.apiRouteSegment}/checkout/verify-checkout-session`;
  }
}
